/**
 * Key / Value pair to translate API keys to better named, camelCased keys.
 * Any keys included in the request / response will be and not mapped here
 * will be removed.
 *
 * Any API response that returns a cursor-based pagination object will be mapped through
 * this object.
 *
 * @var {Object} cursorPaginatedResponseMap
 */
var cursorPaginatedResponseMap = {
  data: 'data',
  next: 'next',
  previous: 'previous',
  hasNext: 'hasNext',
  hasPrevious: 'hasPrevious'
};
export default cursorPaginatedResponseMap;